import React from 'react';
import 'react-block-ui/style.css';
//import LaddaButton, { S, SLIDE_LEFT } from 'react-ladda';
import { Modal, ModalHeader, ModalFooter } from 'reactstrap';

class ClearAllModal extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <Modal className="modal-content" isOpen={this.props.show} autoFocus={false}>
                <ModalHeader toggle={this.props.toggle}>This will clear all notes and annotations you have made to this document.</ModalHeader>
                <ModalFooter>
                    <a
                        className="btn btn-outline-primary "
                        data-dismiss="modal"
                        onClick={() => this.props.close()}
                    >
                        Cancel
                            </a>
                    <button
                        className="btn btn-primary"
                        onClick={() => this.props.clearAll()}
                    >
                        Confirm
                        </button>
                </ModalFooter>
            </Modal >
        );
    }
}

export default ClearAllModal;



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/DocumentViewer/ClearAllModal.js